import { useState, useRef, useCallback } from "react";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";

const VoiceInputButton = ({ onResult, disabled }) => {
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);

  const startListening = useCallback(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      toast.error("Spracheingabe wird von diesem Browser nicht unterstützt");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "de-DE";
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => setListening(true);

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      if (transcript) {
        onResult(transcript);
      }
    };

    recognition.onerror = (event) => {
      if (event.error === "no-speech") {
        toast.info("Keine Sprache erkannt");
      } else if (event.error !== "aborted") {
        toast.error("Fehler bei der Spracheingabe");
      }
      setListening(false);
    };

    recognition.onend = () => setListening(false);

    recognitionRef.current = recognition;
    recognition.start();
  }, [onResult]);

  const stopListening = useCallback(() => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    setListening(false);
  }, []);

  const toggle = () => {
    if (listening) {
      stopListening();
    } else {
      startListening();
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={disabled}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-md transition-colors flex-shrink-0 ${
        listening
          ? "bg-red-500 text-white animate-pulse"
          : "bg-muted hover:bg-muted-foreground/20 text-muted-foreground"
      }`}
      title={listening ? "Stoppen" : "Spracheingabe"}
      data-testid="voice-input-btn"
    >
      {listening ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
    </button>
  );
};

export default VoiceInputButton;
